export default {
  meta: {
    title: 'Ventura Software | Apps móviles y plataformas, hechas en Montevideo',
    description:
      'Un estudio de software en Montevideo, Uruguay. Construimos apps móviles y las plataformas que las sostienen, desde la primera versión hasta producción. Desde 2023.',
  },
  howWeWork: {
    eyebrow: 'Cómo trabajamos',
    title: 'Nuestro horario se cruza con el tuyo',
    body:
      'Montevideo está en UTC-3 todo el año, sin horario de verano. Son 1 a 2 horas más que en la costa este de EE. UU., y nuestras mañanas coinciden con las tardes de Europa central.',
    languages: 'Trabajamos en español e inglés.',
    engagement: {
      start: {
        title: 'Arrancamos con una llamada',
        body: 'Una llamada gratis de 30 minutos para entender qué necesitás. Después te mandamos una propuesta con alcance, plazos y precio.',
      },
      models: {
        title: 'Dos formas de trabajar',
        body: 'Construimos el producto completo de punta a punta, o sumamos ingenieros dedicados a tu equipo. Podés conocerlos antes de arrancar.',
      },
      cadence: {
        title: 'Avances a tu medida',
        body: 'Acordamos con cada cliente cada cuánto mostrar avances: demos, updates por escrito o un canal compartido.',
      },
    },
    you: 'Tu hora',
    overlap: '{{count}} h en común',
    legend: 'Las barras marcan de 9:00 a 18:00, hora local de cada ciudad',
    cities: {
      montevideo: 'Montevideo',
      newYork: 'Nueva York',
      sanFrancisco: 'San Francisco',
      london: 'Londres',
      berlin: 'Berlín',
    },
  },
  featured: {
    eyebrow: 'Trabajos destacados',
    title: 'Trabajos recientes',
    subtitle: 'Tres productos que construimos de punta a punta y seguimos manteniendo.',
    seeAll: 'Ver todos los proyectos',
    items: {
      walo: 'App de reservas y panel de gestión para un estudio de Pilates en Montevideo.',
      bethel: 'App para socios, admin para el staff y check-in con QR para un gimnasio con varias sedes.',
      dmg: 'Sistema de laboratorio que sigue cada muestra desde la recepción hasta el informe firmado.',
    },
  },
  privacyPage: {
    eyebrow: 'Legal',
    title: 'Política de privacidad',
    updated: 'Última actualización: octubre de 2026',
    intro:
      'Esta página explica qué datos personales recoge el sitio de Ventura Software (venturasoftware.dev), para qué, y qué podés hacer al respecto.',
    sections: [
      {
        title: 'Qué datos recogemos',
        body: 'Solo lo que nos mandás por el formulario de contacto: tu nombre, tu email y tu mensaje. Si nos escribís por email o WhatsApp, o agendás una llamada, recibimos lo que elijas compartir ahí.',
      },
      {
        title: 'Para qué los usamos',
        body: 'Solo para responderte y seguir la conversación que iniciaste. No vendemos tus datos, no los usamos para publicidad y no te sumamos a listas de correo.',
      },
      {
        title: 'Quién los procesa',
        body: 'El formulario llega a nuestra casilla a través de EmailJS (emailjs.com). Las llamadas se agendan con Calendly (calendly.com) y los mensajes de WhatsApp pasan por WhatsApp (Meta). Cada servicio tiene su propia política de privacidad. El sitio está alojado en Vercel, que procesa datos técnicos de cada pedido, como la dirección IP, para servir las páginas.',
      },
      {
        title: 'Cookies y seguimiento',
        body: 'Este sitio no usa cookies, analítica ni trackers publicitarios. Las fuentes y los íconos se sirven desde nuestro propio dominio. Si elegís un idioma, esa elección se guarda en tu navegador para recordarla; nunca sale de tu dispositivo.',
      },
      {
        title: 'Cuánto tiempo los guardamos',
        body: 'Guardamos tus mensajes mientras los necesitemos para atender tu consulta y el trabajo que surja de ella. Podés pedirnos que los borremos en cualquier momento.',
      },
      {
        title: 'Tus derechos',
        body: 'Podés pedirnos qué datos tenemos sobre vos, y que los corrijamos o los borremos, escribiendo a info@venturasoftware.dev.',
      },
    ],
    contactTitle: 'Contacto',
    back: 'Volver al inicio',
  },
};
